import {
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    GET_SEARCH_PARAMS_CONTENT_TYPE_LESSON,
    ARE_PARAMS_SEARCHABLE,
    SET_SEARCH_TERM,
    SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON,
    SET_SEARCH_REQUEST_CANCELLATION_SOURCE,
    SEARCH,
    SEARCH_LESSONS,
    GET_SEARCH_PARAMS_CONTENT_TYPE_MASECHET, SEARCH_MASECHETS, SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET,

} from '../services/constants'
import lodash from '../services/lodash'
import http from '../services/axios'

const searchModule = {
    state: {
        searchTerm: '',
        entriesContentTypeLesson: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
        entriesContentTypeMasechet: {
            state: LOADING_PRISTINE,
            data: [],
            error: null,
        },
        cancellationSources: {
            preemptiveCancellationSourceContentTypeLesson: null,
            preemptiveCancellationSourceContentTypeMasechet: null,
        },
    },
    getters: {
        [GET_SEARCH_PARAMS_CONTENT_TYPE_LESSON](state, getters, rootState) {
            return {
                q: state.searchTerm,
                contentType: 'lesson',
                language: rootState.languageModule.currentLanguage.locale,
            }
        },
        [GET_SEARCH_PARAMS_CONTENT_TYPE_MASECHET](state, getters, rootState) {
            return {
                q: state.searchTerm,
                contentType: 'masechet',
                language: rootState.languageModule.currentLanguage.locale,
            }
        },
        [ARE_PARAMS_SEARCHABLE](state) {
            return state.searchTerm !== ''
        },
    },
    mutations: {
        [SET_SEARCH_TERM](state, payload) {
            state.searchTerm = payload
        },
        [SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON](state, payload) {
            state.entriesContentTypeLesson = payload
        },
        [SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET](state, payload) {
            state.entriesContentTypeMasechet = payload
        },
        [SET_SEARCH_REQUEST_CANCELLATION_SOURCE](state, cancellationFunc) {
            state.cancellationSources.preemptiveCancellationSourceContentTypeLesson = cancellationFunc
        },
    },
    actions: {
        [SEARCH](context) {
            return Promise.all([
                context.dispatch(SEARCH_LESSONS),
                context.dispatch(SEARCH_MASECHETS),
            ])
        },
        [SEARCH_LESSONS](context) {
            const previousCancellationSource = context.state.cancellationSources.preemptiveCancellationSourceContentTypeLesson
            if (previousCancellationSource) {
                previousCancellationSource.cancel()
            }
            if (context.getters[ARE_PARAMS_SEARCHABLE]) {
                const paramsObj = context.getters[GET_SEARCH_PARAMS_CONTENT_TYPE_LESSON]

                context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON, {
                    state: LOADING_STARTED,
                    data: context.state.entriesContentTypeLesson.data,
                    error: context.state.entriesContentTypeLesson.error,
                })

                const cancellationSource = http.createCancelSource()
                context.commit(SET_SEARCH_REQUEST_CANCELLATION_SOURCE, cancellationSource)
                const config = {
                    params: paramsObj,
                    cancelToken: cancellationSource.token,
                }

                http.getDelivery('entries/suggest', config).then(response => {
                    context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: Array.isArray(response.data) ? response.data : [],
                        error: null,
                    })
                }).catch(err => {
                    if (http.isCancel(err)) {
                        context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON, {
                            state: context.state.entriesContentTypeLesson.state,
                            data: context.state.entriesContentTypeLesson.data,
                            error: err,
                        })
                    } else {
                        context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON, {
                            state: LOADING_COMPLETED_FAILURE,
                            data: context.state.entriesContentTypeLesson.data,
                            error: err,
                        })
                    }
                })
            } else {
                context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_LESSON, {
                    state: LOADING_PRISTINE,
                    data: [],
                    error: null,
                })
            }
        },
        [SEARCH_MASECHETS](context) {
            const previousCancellationSource = context.state.cancellationSources.preemptiveCancellationSourceContentTypeMasechet
            if (previousCancellationSource) {
                previousCancellationSource.cancel()
            }
            if (context.getters[ARE_PARAMS_SEARCHABLE]) {
                const paramsObj = context.getters[GET_SEARCH_PARAMS_CONTENT_TYPE_MASECHET]

                context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET, {
                    state: LOADING_STARTED,
                    data: context.state.entriesContentTypeMasechet.data,
                    error: context.state.entriesContentTypeMasechet.error,
                })

                const cancellationSource = http.createCancelSource()
                context.commit(SET_SEARCH_REQUEST_CANCELLATION_SOURCE, cancellationSource)
                const config = {
                    params: paramsObj,
                    cancelToken: cancellationSource.token,
                }

                http.getDelivery('entries/suggest', config).then(response => {
                    context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET, {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: Array.isArray(response.data) ? response.data : [],
                        error: null,
                    })
                }).catch(err => {
                    if (http.isCancel(err)) {
                        context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET, {
                            state: context.state.entriesContentTypeLesson.state,
                            data: context.state.entriesContentTypeLesson.data,
                            error: err,
                        })
                    } else {
                        context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET, {
                            state: LOADING_COMPLETED_FAILURE,
                            data: context.state.entriesContentTypeLesson.data,
                            error: err,
                        })
                    }
                })
            } else {
                context.commit(SET_SEARCH_RESULTS_CONTENT_TYPE_MASECHET, {
                    state: LOADING_PRISTINE,
                    data: [],
                    error: null,
                })
            }
        },
    }
}

export default searchModule
export {searchModule}